"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ecoaCrfApi = void 0;
const getEcoaCrfs = {
    method: "GET",
    url: "/ecoa/crfs",
    reducer: resp => resp,
    errReducer: resp => resp,
};
const getEcoaPreScreening = studyId => ({
    method: "GET",
    url: `/studies/${studyId}/ecoa/pre-screening`,
    reducer: resp => resp,
    errReducer: resp => resp,
});
const validateBankingAccount = {
    method: "POST",
    url: `${process.env.REACT_APP_SANTA_BE_URL}/banking/account/validate`,
    reducer: resp => resp,
    errReducer: resp => resp,
};
exports.ecoaCrfApi = { getEcoaCrfs, getEcoaPreScreening, validateBankingAccount };
//# sourceMappingURL=ecoaCrf.js.map